import script from "./ScreeningTitleModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ScreeningTitleModal.vue?vue&type=script&setup=true&lang=js"

import "./ScreeningTitleModal.vue?vue&type=style&index=0&id=6533378e&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6533378e"]])

export default __exports__